import { Box, Chip, CircularProgress, IconButton } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'

export const formatSapSalesOrderRequest = (payload) => {
  if (payload == null || payload === '') return 'No SAP Order payload was stored.'
  if (typeof payload === 'string') return payload
  try {
    return JSON.stringify(payload, null, 2)
  } catch {
    return String(payload)
  }
}

/**
 * Shows the system SAP sales-order-create request (dynamic fields only).
 * Payload is loaded on View via a dedicated API — not from Order Detail.
 * Hidden for manual SO numbers and shipments without a system SO.
 */
export default function SapSalesOrderStatus({
  visible = false,
  onRequestView,
  viewLoading = false,
}) {
  if (!visible) return null

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.75, flexWrap: 'wrap' }}>
      <Chip size="small" label="SAP Order Payload" color="info" variant="outlined" />
      {onRequestView ? (
        <IconButton
          size="small"
          aria-label="View SAP Order payload"
          disabled={viewLoading}
          onClick={() => onRequestView()}
        >
          {viewLoading ? (
            <CircularProgress size={16} />
          ) : (
            <VisibilityIcon fontSize="small" />
          )}
        </IconButton>
      ) : null}
    </Box>
  )
}
